import OAuthIntegration from './OAuthIntegration';

export default class FacebookIntegration extends OAuthIntegration {}
